export default {
    computed: {
        selectOrder() {
			if (! this.selectMap)
				return []
			return Object.keys(this.selectMap).sort((a, b) => (this.selectMap[b].count - this.selectMap[a].count))
		}
    }
}
